import { useMemo } from 'react'
import { useMatch } from 'react-router-dom'
import { LEARN_MY_COURSES_SLUG } from '@/features/layout/LayoutMain/constants'
import { useCommonNavigationItems } from './useCommonNavigationItems'
import { useHasAccessToPortal } from './useHasAccessToPortal'

export const useLayoutVisibility = () => {
  const commonNavigationItems = useCommonNavigationItems()

  const hasAccessToPortal = useHasAccessToPortal()
  const isCoursesPage = useMatch({
    path: '/courses',
    end: true,
  })

  const customNavigationItems = useMemo(
    () =>
      commonNavigationItems.filter((item) => {
        if (typeof item === 'string') return true

        // filter out the My Courses item because it'll be always there
        return item.slug !== LEARN_MY_COURSES_SLUG
      }),
    [commonNavigationItems],
  )

  const hasItems = customNavigationItems.length > 0

  return {
    hamburger: hasItems || (isCoursesPage && hasAccessToPortal),
    sidebar: hasItems,
  }
}
